<template>
  <select-dict
    v-model="aluminiumSort"
    :selectList="aluminiumSorts"
    :select-first-item="true"
  />
</template>

<script setup lang="ts">
import { defineModel } from "vue";
import { useDictStore } from "@/stores/dictStore";

import SelectDict from "@/components/UI/SelectDict.vue";

const dictStore = useDictStore();

const aluminiumSorts = dictStore.getAluminumMaterialTypes();
const aluminiumSort = defineModel<string>();
</script>

<style lang="scss" scoped></style>
